<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#main)
    .pb-16
      v-list-item.document-list-item.mb-3.rounded(
        v-for="({ title, file }, i) in items",
        :key="i"
      )
        v-list-item-content
          v-list-item-title {{ title }}
        v-list-item-action
          v-btn.text-none(
            :class="!sm && 'rounded-pill'",
            :href="files + file",
            target="_blank",
            color="primary",
            depressed,
            :small="sm",
            :fab="sm"
          )
            v-icon(:left="!sm", :small="sm") fas fa-download
            span(v-if="!sm") Download
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";
import CommunicationsWidget from "@/components/widgets/Communications";
import Images from "@/components/sections/Images";
import Videos from "@/components/sections/Videos";

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    pageTitle() {
      return this.$route.meta.title;
    },
    mod() {
      return this.$route.meta.mod;
    },
    itemId() {
      const item = this.$route.params.item;
      return item ? item.replace(/^.*-([0-9]+)$/, "$1") : null;
    },
    items() {
      return this.$rest(this.mod).list;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getContent() {
      this.loading = true;

      const options = {};
      if (this.itemId) options.id = this.itemId;

      this.$rest(this.mod)
        .get(options)
        .then(() => (this.loading = false))
        .catch(() => {
          this.$router.replace("/error404");
        });
    },
  },
  created() {
    this.getContent();
  },
  watch: {
    $route() {
      this.getContent();
    },
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    Images,
    Videos,
  },
};
</script>

<style>
.document-list-item {
  border: 1px solid #ddd;
}
</style>
